import { createSlice } from '@reduxjs/toolkit';

const initialState: WeavePracState = {
  visible: false
};

export interface WeavePracState {
  visible: boolean
}

export const slice = createSlice({
  name: 'weavePrac',
  initialState: initialState,
  reducers: {
    show: (state) => {
      state.visible = true;
    },
    hide: (state) => {
      state.visible = false;
    }
  }
});

export default slice.reducer;
export const { show, hide } = slice.actions;
